export function AddQueryParams(url: string, params: unknown, offset?: number): string {
  // Add query parameters to the url, except the id, if they exist.
  let queryParams = GenerateQueryParams(params);

  if (offset !== undefined) {
    if (queryParams.length > 0) {
      queryParams += `&offset=${offset}`;
    } else {
      queryParams += `offset=${offset}`;
    }
  }

  if (queryParams.length > 0) {
    return `${url}?${queryParams}`;
  } else {
    return url;
  }
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any -- We are using any here because we want to allow any type of object to be passed in as params.
export function GenerateQueryParams(params: any): string {
  const _queryParams: string[] = [];

  for (const _key in params) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access -- We are checking if the key exists in the params object, so this is safe.
    if (params[_key] !== undefined && _key !== 'id') {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access -- We are checking if the key exists in the params object, so this is safe.
      _queryParams.push(`${_key}=${params[_key]}`);
    }
  }

  if (!_queryParams.length) {
    return '';
  }

  return _queryParams.join('&');
}
